import { render, staticRenderFns } from "./CurrentLessons.vue?vue&type=template&id=ecda44de&scoped=true&"
import script from "./CurrentLessons.vue?vue&type=script&lang=js&"
export * from "./CurrentLessons.vue?vue&type=script&lang=js&"
import style0 from "./CurrentLessons.vue?vue&type=style&index=0&id=ecda44de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecda44de",
  null
  
)

export default component.exports